const productsData = [
    {
        id: "1",
        name: '3 1/2" LAKSHMI',
        price: 75,
        offerPrice: 15,
        category: "ONE SOUND CRACKERS",
        image: "1.jpeg"
    },
    {
        id: "2",
        name: '4" LAKSHMI',
        price: 100,
        offerPrice: 20,
        category: "ONE SOUND CRACKERS",
        image: "2.jpeg"
    },
    {
        id: "3",
        name: '4" LAKSHMI DLX',
        price: 150,
        offerPrice: 30,
        category: "ONE SOUND CRACKERS",
        image: "3.jpeg"
    },
    {
        id: "4",
        name: '4" GOLD LAKSHMI',
        price: 180,
        offerPrice: 36,
        category: "ONE SOUND CRACKERS",
        image: "4.jpeg"
    },
    {
        id: "5",
        name: "2 SOUND CRACKERS",
        price: 200,
        offerPrice: 40,
        category: "ONE SOUND CRACKERS",
        image: "5.jpeg"
    },
    {
        id: "6",
        name: '5" LAKSHMI',
        price: 250,
        offerPrice: 50,
        category: "ONE SOUND CRACKERS",
        image: "6.jpeg"
    },
    {
        id: "7",
        name: '6" LAKSHMI',
        price: 300,
        offerPrice: 60,
        category: "ONE SOUND CRACKERS",
        image: "7.jpeg"
    },
    {
        id: "8",
        name: '2 3/4" KURUVI',
        price: 45,
        offerPrice: 9,
        category: "ONE SOUND CRACKERS",
        image: "8.jpeg"
    },
    {
        id: "9",
        name: "RED BIJILI (50PCS)",
        price: 100,
        offerPrice: 20,
        category: "BIJILI CRACKERS",
        image: "9.jpeg"
    },
    {
        id: "10",
        name: "STRIPPED BIJILI (50PCS)",
        price: 120,
        offerPrice: 24,
        category: "BIJILI CRACKERS",
        image: "10.jpeg"
    },
    {
        id: "11",
        name: "RED BIJILI (100PCS)",
        price: 180,
        offerPrice: 36,
        category: "BIJILI CRACKERS",
        image: "11.jpeg"
    },
    {
        id: "12",
        name: "STRIPPED BIJILI (100PCS)",
        price: 190,
        offerPrice: 38,
        category: "BIJILI CRACKERS",
        image: "12.jpeg"
    },
    {
        id: "13",
        name: "FIRE EGG",
        price: 700,
        offerPrice: 140,
        category: "NEW ARRIVALS",
        image: "14.jpeg"
    },
    {
        id: "14",
        name: "HELICOPTER",
        price: 500,
        offerPrice: 100,
        category: "NEW ARRIVALS",
        image: "14.jpeg"
    },
    {
        id: "15",
        name: "RAINBOW",
        price: 700,
        offerPrice: 140,
        category: "NEW ARRIVALS",
        image: "15.jpeg"
    },
    {
        id: "16",
        name: "BLACK & WHITE (OLAI VEDI 25PCS)",
        price: 850,
        offerPrice: 170,
        category: "NEW ARRIVALS",
        image: "16.jpeg"
    },
    {
        id: "17",
        name: "MONEY BLAST (3PCS)",
        price: 900,
        offerPrice: 180,
        category: "NEW ARRIVALS",
        image: "17.jpeg"
    },
    {
        id: "18",
        name: "HANUMAN GADAYUTHAM SHOWER",
        price: 850,
        offerPrice: 170,
        category: "NEW ARRIVALS",
        image: "18.jpeg"
    },
    {
        id: "19",
        name: "HITAR WATER SHOWER",
        price: 900,
        offerPrice: 180,
        category: "NEW ARRIVALS",
        image: "19.jpeg"
    },
    {
        id: "20",
        name: "JOY ELEPHANT",
        price: 900,
        offerPrice: 180,
        category: "NEW ARRIVALS",
        image: "20.jpeg"
    },
    {
        id: "21",
        name: "GROUND CHAKKAR BIG",
        price: 240,
        offerPrice: 48,
        category: "GROUND CHAKKARS",
        image: "21.jpeg"
    },
    {
        id: "22",
        name: "GROUND CHAKKAR SPL",
        price: 400,
        offerPrice: 80,
        category: "GROUND CHAKKARS",
        image: "22.jpeg"
    },
    {
        id: "23",
        name: "GROUND CHAKKAR DELUXE",
        price: 675,
        offerPrice: 135,
        category: "GROUND CHAKKARS",
        image: "23.jpeg"
    },
    {
        id: "24",
        name: "SPINNER SPL",
        price: 750,
        offerPrice: 150,
        category: "GROUND CHAKKARS",
        image: "24.jpeg"
    },
    {
        id: "25",
        name: "SPINNER DLX",
        price: 900,
        offerPrice: 180,
        category: "GROUND CHAKKARS",
        image: "25.jpeg"
    },
    {
        id: "26",
        name: "",
        price: 900,
        offerPrice: 180,
        category: "GROUND CHAKKARS",
        image: "26.jpeg"
    },
    {
        id: "27",
        name: "FLOWER POTS BIG",
        price: 375,
        offerPrice: 75,
        category: "FLOWER POTS",
        image: "27.jpeg"
    },
    {
        id: "28",
        name: "FLOWER POTS SPL",
        price: 425,
        offerPrice: 85,
        category: "FLOWER POTS",
        image: "28.jpeg"
    },
    {
        id: "29",
        name: "FLOWER POTS ASOKA",
        price: 650,
        offerPrice: 130,
        category: "FLOWER POTS",
        image: "29.jpeg"
    },
    {
        id: "30",
        name: "COLOR KOTI",
        price: 950,
        offerPrice: 190,
        category: "FLOWER POTS",
        image: "30.jpeg"
    },
    {
        id: "31",
        name: "FLOWER POTS DLX (5 PCS)",
        price: 900,
        offerPrice: 180,
        category: "FLOWER POTS",
        image: "31.jpeg"
    },
    // ROCKET
    {
        id: "32",
        name: "ROCKET BOMB",
        price: 350,
        offerPrice: 70,
        category: "ROCKET",
        image: "32.jpeg"
    },
    {
        id: "33",
        name: "LUNIK ROCKETS",
        price: 800,
        offerPrice: 160,
        category: "ROCKET",
        image: "33.jpeg"
    },
    {
        id: "34",
        name: "2 SOUND ROCKETS",
        price: 850,
        offerPrice: 170,
        category: "ROCKET",
        image: "34.jpeg"
    },

// ATOM BOMBS
    {
        id: "35",
        name: "HYDRO BOMB",
        price: 400,
        offerPrice: 80,
        category: "ATOM BOMBS",
        image: "35.jpeg"
    },
    {
        id: "36",
        name: "CLASSIC BOMB",
        price: 650,
        offerPrice: 130,
        category: "ATOM BOMBS",
        image: "36.jpeg"
    },
    {
        id: "37",
        name: "KING OF KING",
        price: 700,
        offerPrice: 140,
        category: "ATOM BOMBS",
        image: "37.jpeg"
    },
    {
        id: "38",
        name: "DIGITAL BOMB",
        price: 1250,
        offerPrice: 250,
        category: "ATOM BOMBS",
        image: "38.jpeg"
    },
    {
        id: "39",
        name: "PAPER SHOT 1/4 KG",
        price: 250,
        offerPrice: 50,
        category: "ATOM BOMBS",
        image: "39.jpeg"
    },
    {
        id: "40",
        name: "PAPER SHOT 1/2 KG",
        price: 475,
        offerPrice: 95,
        category: "ATOM BOMBS",
        image: "40.jpeg"
    },
    {
        id: "41",
        name: "PAPER SHOT 1 KG",
        price: 950,
        offerPrice: 190,
        category: "ATOM BOMBS",
        image: "41.jpeg"
    },

// TWINKLE STARS
    {
        id: "42",
        name: "1 1/2 TWINKLE STARS",
        price: 150,
        offerPrice: 30,
        category: "TWINKLE STARS",
        image: "41.jpeg"
    },
    {
        id: "43",
        name: '4" TWINKLE STARS',
        price: 375,
        offerPrice: 75,
        category: "TWINKLE STARS",
        image: "43.jpeg"
    },

// FANCY PENCILS
    {
        id: "44",
        name: "POPCORN PENCIL 5 PCS",
        price: 800,
        offerPrice: 160,
        category: "FANCY PENCILS",
        image: "44.jpeg"
    },
    {
        id: "45",
        name: "WATER FALLS PENCIL 5 PCS",
        price: 900,
        offerPrice: 180,
        category: "FANCY PENCILS",
        image: "45.jpeg"
    },

// COLOUR MATCHES
    {
        id: "46",
        name: "COLOUR MATCH LAPTOP",
        price: 900,
        offerPrice: 180,
        category: "COLOUR MATCHES",
        image: "46.jpeg"
    },
    {
        id: "47",
        name: "COLOR MATCHES DLX",
        price: 1300,
        offerPrice: 260,
        category: "COLOUR MATCHES",
        image: "47.jpeg"
    },

// FANCY FOUNTAINS
    {
        id: "48",
        name: "LITTLE POTS",
        price: 550,
        offerPrice: 110,
        category: "FANCY FOUNTAINS",
        image: "48.jpeg"
    },
    {
        id: "49",
        name: "TRI COLOR FOUNTAIN",
        price: 1250,
        offerPrice: 250,
        category: "FANCY FOUNTAINS",
        image: "49.jpeg"
    },
    {
        id: "50",
        name: "PEACOCK COLOR MIX",
        price: 800,
        offerPrice: 160,
        category: "FANCY FOUNTAINS",
        image: "50.jpeg"
    },
    {
        id: "51",
        name: "SIREN 5PCS",
        price: 750,
        offerPrice: 150,
        category: "FANCY FOUNTAINS",
        image: "51.jpeg"
    },
    {
        id: "52",
        name: "MEGA SIREN 3PCS",
        price: 850,
        offerPrice: 170,
        category: "FANCY FOUNTAINS",
        image: "52.jpeg"
    },
    {
        id: "53",
        name: "MAGIC BUTTERFLY (10PCS)",
        price: 500,
        offerPrice: 100,
        category: "FANCY FOUNTAINS",
        image: "53.jpeg"
    },
    {
        id: "54",
        name: "BADA PEACOCK",
        price: 2000,
        offerPrice: 400,
        category: "FANCY FOUNTAINS",
        image: "54.jpeg"
    },
    {
        id: "55",
        name: "EMOJI CRACKLING",
        price: 850,
        offerPrice: 170,
        category: "FANCY FOUNTAINS",
        image: "55.jpeg"
    },
    {
        id: "56",
        name: "LAVA,UNDO,RETO",
        price: 1050,
        offerPrice: 210,
        category: "FANCY FOUNTAINS",
        image: "56.jpeg"
    },
    {
        id: "57",
        name: "JUNIPER GREEN WINDOW PACK(6PCS)",
        price: 850,
        offerPrice: 170,
        category: "FANCY FOUNTAINS",
        image: "57.jpeg"
    },
    {
        id: "58",
        name: "LIVE SHOW",
        price: 900,
        offerPrice: 180,
        category: "FANCY FOUNTAINS",
        image: "58.jpeg"
    },
    {
        id: "59",
        name: "GOLDERN IGNOT WINDOW PACK(6PCS)",
        price: 850,
        offerPrice: 170,
        category: "FANCY FOUNTAINS",
        image: "59.jpeg"
    },
    {
        id: "60",
        name: "SHINING STAR CRACKLING",
        price: 1500,
        offerPrice: 300,
        category: "FANCY FOUNTAINS",
        image: "60.jpeg"
    },
    {
        id: "61",
        name: "SOUUND PARTY (3 PCS)",
        price: 850,
        offerPrice: 170,
        category: "FANCY FOUNTAINS",
        image: "61.jpeg"
    },
    {
        id: "62",
        name: "SUPER SINGER (5 PCS)",
        price: 850,
        offerPrice: 170,
        category: "FANCY FOUNTAINS",
        image: "62.jpeg"
    },
    {
        id: "63",
        name: "GOLDEN SPARROW (5PCS)",
        price: 750,
        offerPrice: 150,
        category: "FANCY FOUNTAINS",
        image: "63.jpeg"
    },
    {
        id: "64",
        name: "COLOUR SMOKE MULTICOLOR (NAACHIAR SPL)",
        price: 1000,
        offerPrice: 200,
        category: "FANCY FOUNTAINS",
        image: "64.jpeg"
    },
    {
        id: "65",
        name: "SKY SHOT 10PCS",
        price: 750,
        offerPrice: 150,
        category: "AERIAL NOVELTIES",
        image: "65.jpeg"
    },
    {
        id: "66",
        name: '1" CHOTTA MULTI',
        price: 200,
        offerPrice: 40,
        category: "AERIAL NOVELTIES",
        image: "66.jpeg"
    },
    {
        id: "67",
        name: "3 PCS FANCY MULTI COLOUR",
        price: 1500,
        offerPrice: 300,
        category: "AERIAL NOVELTIES",
        image: "67.jpeg"
    },
    {
        id: "68",
        name: '2" FANCY PIPE',
        price: 750,
        offerPrice: 150,
        category: "AERIAL NOVELTIES",
        image: "68.jpeg"
    },
    {
        id: "69",
        name: '3" FANCY PIPE',
        price: 1500,
        offerPrice: 300,
        category: "AERIAL NOVELTIES",
        image: "69.jpeg"
    },
    {
        id: "70",
        name: '3 1/2" FANCY PIPE',
        price: 1750,
        offerPrice: 350,
        category: "AERIAL NOVELTIES",
        image: "70.jpeg"
    },
    {
        id: "71",
        name: '4" FANCY PIPE (DOUBLE BALL)',
        price: 2300,
        offerPrice: 460,
        category: "AERIAL NOVELTIES",
        image: "71.jpeg"
    },
    {
        id: "72",
        name: '5" FANCY PIPE MULTI COLOR',
        price: 2700,
        offerPrice: 540,
        category: "AERIAL NOVELTIES",
        image: "72.jpeg"
    },
    // REPEATING SHOTS MULTI COLOURS
    {
        id: "73",
        name: "7 SHOT",
        price: 650,
        offerPrice: 130,
        category: "REPEATING SHOTS MULTI COLOURS",
        image: "73.jpeg"
    },
    {
        id: "74",
        name: "12 SHOT",
        price: 850,
        offerPrice: 170,
        category: "REPEATING SHOTS MULTI COLOURS",
        image: "74.jpeg"
    },
    {
        id: "75",
        name: "12 SHOT MULTI COLOUR",
        price: 900,
        offerPrice: 180,
        category: "REPEATING SHOTS MULTI COLOURS",
        image: "75.jpeg"
    },
    {
        id: "76",
        name: "12 SHOT MAGIC",
        price: 1000,
        offerPrice: 200,
        category: "REPEATING SHOTS MULTI COLOURS",
        image: "76.jpeg"
    },
    {
        id: "77",
        name: "15 SHOTS SPL",
        price: 1250,
        offerPrice: 250,
        category: "REPEATING SHOTS MULTI COLOURS",
        image: "77.jpeg"
    },
    {
        id: "78",
        name: "25 SHOTS MUTI COLOUR",
        price: 1600,
        offerPrice: 320,
        category: "REPEATING SHOTS MULTI COLOURS",
        image: "78.jpeg"
    },
    {
        id: "79",
        name: "30 SHOTS MULTICOLOUR",
        price: 2025,
        offerPrice: 405,
        category: "REPEATING SHOTS MULTI COLOURS",
        image: "79.jpeg"
    },
    {
        id: "80",
        name: "60 SHOTS MULTICOLOURS",
        price: 4100,
        offerPrice: 820,
        category: "REPEATING SHOTS MULTI COLOURS",
        image: "80.jpeg"
    },
    {
        id: "81",
        name: "120 SHOTS MULTICOLOUS",
        price: 8200,
        offerPrice: 1640,
        category: "REPEATING SHOTS MULTI COLOURS",
        image: "81.jpeg"
    },
    {
        id: "82",
        name: "240 SHOTS MULTICOLOURS",
        price: 16400,
        offerPrice: 3280,
        category: "REPEATING SHOTS MULTI COLOURS",
        image: "82.jpeg"
    },

// SPARKLERS
    {
        id: "83",
        name: "7 CM ELECTRIC SPARKLERS",
        price: 50,
        offerPrice: 10,
        category: "SPARKLERS",
        image: "83.jpeg"
    },
    {
        id: "84",
        name: "7 CM COLOUR SPARKLERS",
        price: 60,
        offerPrice: 12,
        category: "SPARKLERS",
        image: "84.jpeg"
    },
    {
        id: "85",
        name: "7 CM GREEN SPARKLERS",
        price: 70,
        offerPrice: 14,
        category: "SPARKLERS",
        image: "85.jpeg"
    },
    {
        id: "86",
        name: "7 CM RED SPARKLERS",
        price: 80,
        offerPrice: 16,
        category: "SPARKLERS",
        image: "86.jpeg"
    },
    {
        id: "87",
        name: "10 CM ELECTRIC SPARKLERS",
        price: 100,
        offerPrice: 20,
        category: "SPARKLERS",
        image: "87.jpeg"
    },
    {
        id: "88",
        name: "10 CM COLOUR SPARKLERS",
        price: 110,
        offerPrice: 22,
        category: "SPARKLERS",
        image: "88.jpeg"
    },
    {
        id: "89",
        name: "10 CM GREEN SPARKLERS",
        price: 120,
        offerPrice: 24,
        category: "SPARKLERS",
        image: "89.jpeg"
    },
    {
        id: "90",
        name: "10 CM RED SPARKLERS",
        price: 130,
        offerPrice: 26,
        category: "SPARKLERS",
        image: "90.jpeg"
    },
    {
        id: "91",
        name: "12 CM ELECTRIC SPARKLERS",
        price: 130,
        offerPrice: 26,
        category: "SPARKLERS",
        image: "91.jpeg"
    },
    {
        id: "92",
        name: "12 CM COLOUR SPARKLERS",
        price: 140,
        offerPrice: 28,
        category: "SPARKLERS",
        image: "92.jpeg"
    },
    {
        id: "93",
        name: "12 CM GREEN SPARKLERS",
        price: 150,
        offerPrice: 30,
        category: "SPARKLERS",
        image: "93.jpeg"
    },
    {
        id: "94",
        name: "15 CM RED SPARKLERS",
        price: 150,
        offerPrice: 30,
        category: "SPARKLERS",
        image: "94.jpeg"
    },
    {
        id: "95",
        name: "15 CM ELECTRIC SPARKLERS",
        price: 160,
        offerPrice: 32,
        category: "SPARKLERS",
        image: "95.jpeg"
    },
    {
        id: "96",
        name: "15 CM COLOUR SPARKLERS",
        price: 170,
        offerPrice: 34,
        category: "SPARKLERS",
        image: "96.jpeg"
    },
    {
        id: "97",
        name: "15 CM GREEN SPARKLERS",
        price: 180,
        offerPrice: 36,
        category: "SPARKLERS",
        image: "97.jpeg"
    },
    {
        id: "98",
        name: "15 CM RED SPARKLERS",
        price: 190,
        offerPrice: 38,
        category: "SPARKLERS",
        image: "98.jpeg"
    },
    {
        id: "99",
        name: "30 CM ELECTRIC SPARKLERS",
        price: 190,
        offerPrice: 38,
        category: "SPARKLERS",
        image: "99.jpeg"
    },
    {
        id: "100",
        name: "30 CM COLOUR SPARKLERS",
        price: 200,
        offerPrice: 40,
        category: "SPARKLERS",
        image: "100.jpeg"
    },
    {
        id: "101",
        name: "30 CM GREEN SPARKLERS",
        price: 220,
        offerPrice: 44,
        category: "SPARKLERS",
        image: "101.jpeg"
    },
    {
        id: "102",
        name: "30 CM RED SPARKLERS",
        price: 250,
        offerPrice: 50,
        category: "SPARKLERS",
        image: "102.jpeg"
    },
    {
        id: "103",
        name: "50 CM ELECTRIC SPARKLERS",
        price: 800,
        offerPrice: 160,
        category: "SPARKLERS",
        image: "103.jpeg"
    },
    {
        id: "104",
        name: "50 CM COLOUR SPARKLERS",
        price: 1000,
        offerPrice: 200,
        category: "SPARKLERS",
        image: "104.jpeg"
    },
    {
        id: "105",
        name: "75 CM COLOUR SPARKLERS",
        price: 1125,
        offerPrice: 225,
        category: "SPARKLERS",
        image: "105.jpeg"
    },

// NEW NOVELTIES SPARKLERS
    {
        id: "106",
        name: "10 CM SILVER SPARKLERS",
        price: 125,
        offerPrice: 25,
        category: "NEW NOVELTIES SPARKLERS",
        image: "106.jpeg"
    },
    {
        id: "107",
        name: "15 CM SILVER SPARKLERS",
        price: 300,
        offerPrice: 60,
        category: "NEW NOVELTIES SPARKLERS",
        image: "107.jpeg"
    },
    {
        id: "108",
        name: "15 CM SPARKLERS",
        price: 1250,
        offerPrice: 250,
        category: "NEW NOVELTIES SPARKLERS",
        image: "108.jpeg"
    },
    {
        id: "109",
        name: "50 MULTI MIX SPARKLERS",
        price: 1150,
        offerPrice: 230,
        category: "NEW NOVELTIES SPARKLERS",
        image: "109.jpeg"
    },
    {
        id: "110",
        name: "ROTATING SPARKLERS",
        price: 1000,
        offerPrice: 200,
        category: "NEW NOVELTIES SPARKLERS",
        image: "110.jpeg"
    },

// NEW NOVELTIES
    {
        id: "111",
        name: "LIGHTING FLASH",
        price: 350,
        offerPrice: 70,
        category: "NEW NOVELTIES",
        image: "111.jpeg"
    },
    {
        id: "112",
        name: "DISCO SHOWER",
        price: 800,
        offerPrice: 160,
        category: "NEW NOVELTIES",
        image: "112.jpeg"
    },
    {
        id: "113",
        name: "DANCING WHEEL",
        price: 500,
        offerPrice: 100,
        category: "NEW NOVELTIES",
        image: "113.jpeg"
    },
    {
        id: "114",
        name: "LOTUS WHEEL",
        price: 750,
        offerPrice: 150,
        category: "NEW NOVELTIES",
        image: "114.jpeg"
    },
    {
        id: "115",
        name: "VANITHA GOLDEN DUCK",
        price: 4500,
        offerPrice: 900,
        category: "NEW NOVELTIES",
        image: "115.jpeg"
    },
    {
        id: "116",
        name: "VANITHA GOLDEN LION",
        price: 5200,
        offerPrice: 1040,
        category: "NEW NOVELTIES",
        image: "116.jpeg"
    },

// WALA AGE BOY
    {
        id: "117",
        name: "1 WALA AGE",
        price: 1250,
        offerPrice: 250,
        category: "WALA AGE BOY",
        image: "117.jpeg"
    },
    {
        id: "118",
        name: "2 WALA AGE",
        price: 2500,
        offerPrice: 500,
        category: "WALA AGE BOY",
        image: "118.jpeg"
    },
    {
        id: "119",
        name: "5 WALA AGE",
        price: 5000,
        offerPrice: 1000,
        category: "WALA AGE BOY",
        image: "119.jpeg"
    },
    {
        id: "120",
        name: "10 WALA AGE",
        price: 10000,
        offerPrice: 2000,
        category: "WALA AGE BOY",
        image: "120.jpeg"
    },

// MULTI DIPLAY SHOTS
    {
        id: "121",
        name: '1 1/4" FANCY SETOUT',
        price: 6000,
        offerPrice: 1200,
        category: "MULTI DIPLAY SHOTS",
        image: "121.jpeg"
    },
    {
        id: "122",
        name: '2" FANCY SETOUT',
        price: 17500,
        offerPrice: 3500,
        category: "MULTI DIPLAY SHOTS",
        image: "122.jpeg"
    },
    {
        id: "123",
        name: '3" FANCY SETOUT',
        price: 32000,
        offerPrice: 6400,
        category: "MULTI DIPLAY SHOTS",
        image: "123.jpeg"
    },
    {
        id: "124",
        name: '4" FANCY SETOUT',
        price: 42000,
        offerPrice: 8400,
        category: "MULTI DIPLAY SHOTS",
        image: "124.jpeg"
    },

// GIFT BOX NON DISCOUNT
    {
        id: "125",
        name: "21 ITEM GIFT BOX",
        price: 300,
        offerPrice: 300,
        category: "GIFT BOX NON DISCOUNT",
        image: "125.jpeg"
    },
    {
        id: "126",
        name: "31 ITEM GIFT BOX",
        price: 450,
        offerPrice: 450,
        category: "GIFT BOX NON DISCOUNT",
        image: "126.jpeg"
    },
    {
        id: "127",
        name: "41 ITEM GIFT BOX",
        price: 750,
        offerPrice: 750,
        category: "GIFT BOX NON DISCOUNT",
        image: "127.jpeg"
    },
    {
        id: "128",
        name: "51 ITEM GIFT BOX VIP BOX",
        price: 1000,
        offerPrice: 1000,
        category: "GIFT BOX NON DISCOUNT",
        image: "128.jpeg"
    },
    {
        id: "129",
        name: "61 ITEM GIFT BOX VIP BOX",
        price: 1500,
        offerPrice: 1500,
        category: "GIFT BOX NON DISCOUNT",
        image: "129.jpeg"
    }
];

export default productsData;